import React from 'react';
import { Checkbox, FormControl, MenuItem, Select, TextField, Typography } from '@mui/material';

interface ScoringConfigSectionProps {
  enableScoring: boolean;
  scoringMode: string;
  scoringTitle: string;
  onEnableScoringChange: (checked: boolean) => void;
  onScoringModeChange: (mode: string) => void;
  onScoringTitleChange: (title: string) => void;
  gap?: string | number;
}

const labelStyle = {
  fontFamily: 'Montserrat',
  fontSize: '14px',
  fontWeight: 600,
  lineHeight: '24px',
  letterSpacing: '0px',
  textAlign: 'left' as const,
  color: '#10383D',
};

const ScoringConfigSection: React.FC<ScoringConfigSectionProps> = ({
  enableScoring,
  scoringMode,
  scoringTitle,
  onEnableScoringChange,
  onScoringModeChange,
  onScoringTitleChange,
  gap = 289,
}) => {
  const rowStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap,
    marginTop: '15px',
  };

  return (
    <>
      <div style={rowStyle}>
        <Typography sx={labelStyle}>Score a Config</Typography>
        <Checkbox
          checked={enableScoring}
          onChange={(e) => onEnableScoringChange(e.target.checked)}
          color="primary"
        />
      </div>

      {enableScoring && (
        <>
          <div style={rowStyle}>
            <Typography sx={labelStyle}>Scoring Mode</Typography>
            <FormControl size="small">
              <Select
                value={scoringMode}
                onChange={(e) => onScoringModeChange(e.target.value)}
                sx={{ minWidth: 200 }}
                displayEmpty
              >
                <MenuItem value="AUTO">Auto Scoring</MenuItem>
                <MenuItem value="MANUAL">Manual Scoring</MenuItem>
              </Select>
            </FormControl>
          </div>

          {scoringMode === 'MANUAL' && (
            <div style={rowStyle}>
              <Typography sx={labelStyle}>Scoring Title</Typography>
              <TextField
                placeholder="Enter Scoring Title"
                value={scoringTitle}
                onChange={(e) => onScoringTitleChange(e.target.value)}
                size="small"
                sx={{ minWidth: 200 }}
              />
            </div>
          )}
        </>
      )}
    </>
  );
};

export default ScoringConfigSection;

